import * as React from "react";

import Grid from "src/library/components/Hedron";
import ThemeColors from "src/core/global-config/theme/components/ThemeColors";
import ThemeFont from "src/core/global-config/theme/components/ThemeFont";
import ThemeLogo from "src/core/global-config/theme/components/ThemeLogo";
import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import { PageProps } from "src/pages/Router/routes";
import { useCurrentUser } from "src/core/users/hooks";

/**
 * Logo and colors page
 *
 * @returns
 */
const LogoColorsFontPage: React.ReactFCWithChildren<PageProps<unknown>> = props => {
  const [ { currentRole } ] = useCurrentUser();

  return (
    <Layout {...props}>
      <MainContentWrapper fill>
        <Grid.Bounds direction="vertical">
          <ThemeLogo />

          <ThemeColors />

          {currentRole?.code === "super-admin" && (
            <ThemeFont />
          )}
        </Grid.Bounds>
      </MainContentWrapper>
    </Layout>
  );
};

export default LogoColorsFontPage;
